import LeaveMaster from './leaveMaster';
export default LeaveMaster;